import {useMemo} from "react";
import {matchPath, useLocation} from "react-router";
import {css} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {useIsPrint} from "@pg-mono/hooks";
import {WeglotLangSwitcher} from "@pg-mono/i18n";
import {rpAppPath} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";
import {Footer as DesignFooter} from "@pg-rp/footer";

import {useFooterNavData} from "../hooks/use_footer_nav_data";
import {useTopArticlesLinks} from "../hooks/use_top_articles_links";
import {hitLangSwitch} from "../tracking/track_lang_switcher";

declare global {
    interface Window {
        Cookiebot?: {renew: () => void};
    }
}

export const Footer = () => {
    const {isMobile} = useUserDevice();
    const isPrint = useIsPrint();
    const location = useLocation();
    const topArticles = useTopArticlesLinks();
    const footerNavDataBase = useFooterNavData();
    const footerNavData = useMemo(() => ({...footerNavDataBase, topArticles}), [topArticles]);

    const footerExcludedPaths = [
        {path: rpAppPath.offer.map, exact: true, strict: true},
        {path: rpAppPath.friendlyOfferListMap.base, exact: true, strict: true},
        {path: rpAppPath.multiOfferList.map, exact: true, strict: true},
        {path: rpAppPath.investmentOffer.investmentCategory.map, exact: true, strict: true},
        {path: rpAppPath.investmentOffer.investmentCategory.subcategory.map, exact: true, strict: true}
    ];

    const isFooterExcluded = footerExcludedPaths.some((excludedPath) => matchPath(location.pathname, excludedPath));

    if (isFooterExcluded || isPrint) return null;

    return (
        <div className={footerBg}>
            <WideContent>
                <DesignFooter footerMenuData={footerNavData} langSwitcher={<WeglotLangSwitcher isMobile={!!isMobile} onLangChange={hitLangSwitch} />} />
            </WideContent>
        </div>
    );
};

const footerBg = css({
    backgroundColor: "var(--colors-secondary)"
});
import {useMemo} from "react";
import {matchPath, useLocation} from "react-router";
import {css} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {useIsPrint} from "@pg-mono/hooks";
import {WeglotLangSwitcher} from "@pg-mono/i18n";
import {rpAppPath} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";
import {Footer as DesignFooter} from "@pg-rp/footer";

import {useFooterNavData} from "../hooks/use_footer_nav_data";
import {useTopArticlesLinks} from "../hooks/use_top_articles_links";
import {hitLangSwitch} from "../tracking/track_lang_switcher";

declare global {
    interface Window {
        Cookiebot?: {renew: () => void};
    }
}

export const Footer = () => {
    const {isMobile} = useUserDevice();
    const isPrint = useIsPrint();
    const location = useLocation();
    const topArticles = useTopArticlesLinks();
    const footerNavDataBase = useFooterNavData();
    const footerNavData = useMemo(() => ({...footerNavDataBase, topArticles}), [topArticles]);

    const footerExcludedPaths = [
        {path: rpAppPath.offer.map, exact: true, strict: true},
        {path: rpAppPath.friendlyOfferListMap.base, exact: true, strict: true},
        {path: rpAppPath.multiOfferList.map, exact: true, strict: true},
        {path: rpAppPath.investmentOffer.investmentCategory.map, exact: true, strict: true},
        {path: rpAppPath.investmentOffer.investmentCategory.subcategory.map, exact: true, strict: true}
    ];

    const isFooterExcluded = footerExcludedPaths.some((excludedPath) => matchPath(location.pathname, excludedPath));

    if (isFooterExcluded || isPrint) return null;

    return (
        <div className={footerBg}>
            <WideContent>
                <DesignFooter footerMenuData={footerNavData} langSwitcher={<WeglotLangSwitcher isMobile={!!isMobile} onLangChange={hitLangSwitch} />} />
            </WideContent>
        </div>
    );
};

const footerBg = css({
    backgroundColor: "var(--colors-secondary)"
});
